export const HEAP_APP_ID = '1303313745'
export const LOGROCKET_ID = 'aostl4/admin-console-prod'
